import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/active-subscription-stats`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const activeSubscriptionStats = {
  get: apiPathFunc(pathBase),
};
